<template>
  <div
    class="message__system animate__animated animate__fadeInUp animate__faster"
  >
    {{ messageContent }}
  </div>
</template>

<script>
export default {
  props: {
    messageContent: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.message__system {
  @apply bg-purple-10 py-3 px-4 rounded-xl w-max;
  @apply mb-3 text-sm break-words;
  max-width: 270px;
}
</style>
